import { render, staticRenderFns } from "./SocialLinkInfo.vue?vue&type=template&id=b0c12056&"
import script from "./SocialLinkInfo.vue?vue&type=script&lang=js&"
export * from "./SocialLinkInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports